import { render, staticRenderFns } from "./reason-for-denial-widget.vue?vue&type=template&id=5ec5fc9f&"
import script from "./reason-for-denial-widget.vue?vue&type=script&lang=js&"
export * from "./reason-for-denial-widget.vue?vue&type=script&lang=js&"
import style0 from "./reason-for-denial-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports